import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnserviceableComponent } from './unserviceable/unserviceable.component';
import { ShowDynamicQRComponent } from './show-dynamic-qr/show-dynamic-qr.component';
import { NoCashPaymentComponent } from './modules/no-cash-payment/no-cash-payment.component';


const routes: Routes = [
  { path: '', redirectTo: 'menus', pathMatch: 'full' },
  {
    path: 'showqr', component: ShowDynamicQRComponent
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'menus',
    loadChildren: () =>
      import('./modules/food-types/food-types.module').then((m) => m.FoodTypesModule)
  },
  {
    path: 'menus/:tenant',
    loadChildren: () =>
      import('./modules/food-types/food-types.module').then((m) => m.FoodTypesModule)
  },
  {
    path: 'menus/:tenant/:table',
    loadChildren: () =>
      import('./modules/food-types/food-types.module').then((m) => m.FoodTypesModule)
  },
  {
    path: 'categories',
    loadChildren: () =>
      import('./modules/menu-categories/menu-categories.module').then((m) => m.MenuCategoriesModule)
  },
  {
    path: 'categories/:tenant',
    loadChildren: () =>
      import('./modules/menu-categories/menu-categories.module').then((m) => m.MenuCategoriesModule)
  },
  {
    path: 'categories/:tenant/:table',
    loadChildren: () =>
      import('./modules/menu-categories/menu-categories.module').then((m) => m.MenuCategoriesModule)
  },
  {
    path: 'categories_items',
    loadChildren: () =>
      import('./modules/menu-items/menu-items.module').then((m) => m.MenuItemsModule)
  },
  {
    path: 'manageItems',
    loadChildren: () =>
      import('./modules/manage-items/manage-items.module').then((m) => m.ManageItemsModule)
  },
  {
    path: 'manageItems/:tenant',
    loadChildren: () =>
      import('./modules/manage-items/manage-items.module').then((m) => m.ManageItemsModule)
  },
  {
    path: 'manageItems/:tenant/:table',
    loadChildren: () =>
      import('./modules/manage-items/manage-items.module').then((m) => m.ManageItemsModule)
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./modules/checkout/checkout.module').then((m) => m.CheckoutModule)
  },
  {
    path: 'menu',
    loadChildren: () =>
      import('./modules/after-payment/after-payment.module').then((m) => m.AfterPaymentModule)
  },
  {
    path: 'myaccount',
    loadChildren: () =>
      import('./modules/my-account/my-account.module').then((m) => m.MyAccountModule)
  },
  {
    path: 'loader',
    loadChildren: () =>
      import('./modules/payment-loader/payment-loader.module').then((m) => m.PaymentLoaderModule)
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./modules/address/address.module').then((m) => m.AddressModule)
  },
  {
    path: 'wera',
    loadChildren: () =>
      import('./wera-menu/wera-menu.module').then((m) => m.WeraMenuModule)
  },
  {
    path: 'noCash',
    component: NoCashPaymentComponent
  },
  { path: 'unserviceable', component: UnserviceableComponent },
  { path: '**', redirectTo: 'about' },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {


}
